import Vue from 'vue'
import App from './App.vue'
import router from './Routes'
import store from './store/index'
import vuetify from './plugins/vuetify'
import axios from 'axios'
//import airtable from 'airtable'
import config from "./config";
import * as VueGoogleMaps from 'vue2-google-maps'
import * as Realm from "realm-web";
import {AuthMixin} from "./mixins/auth"

axios.defaults.baseURL = config.baseURLApi;
axios.defaults.headers.common['Content-Type'] = "application/json";
const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common['Authorization'] = "Bearer " + token;
}

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBmMGqD1dsLz5BerEOUgH3zYCx3kaHo4vY',
  },
});
Vue.mixin(AuthMixin);

Vue.config.productionTip = false;

new Realm.App({ id: "REALM_APP_ID" });

new Vue({
  vuetify,
  router,
  render: h => h(App), store
}).$mount('#app');
